import React, { useMemo } from 'react';
import './InstrumentHistoryList.css';

const InstrumentHistoryList = ({
  instruments = [],
  selectedInstrument,
  onInstrumentSelect,
}) => {
  const sortedInstruments = useMemo(() => (
    [...instruments].sort((a, b) => (b.timestamp || 0) - (a.timestamp || 0))
  ), [instruments]);

  if (sortedInstruments.length === 0) {
    return (
      <div className="mobile-instrument-history empty">
        <p className="mobile-instrument-empty">
          No recent instruments yet. Search above to add one.
        </p>
      </div>
    );
  }

  return (
    <div className="mobile-instrument-history">
      {sortedInstruments.map((item) => (
        <button
          key={item.instrument}
          type="button"
          className={`mobile-instrument-item ${selectedInstrument === item.instrument ? 'selected' : ''}`}
          onClick={() => onInstrumentSelect(item.instrument, item.category)}
        >
          <span className="mobile-instrument-label">{item.label || item.instrument}</span>
          <span className="mobile-instrument-category">{item.category}</span>
        </button>
      ))}
    </div>
  );
};

export default InstrumentHistoryList;
